import { Autocomplete, Input } from '@fullscreendigital/carrefour-dex-fe'

export const columns = [
  {
    title: 'Tip magazin',
    field: 'shopType',
    align: 'left',
    type: 'string',
    minWidth: '100px'
  },
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    render: row => `${row.shopName} (${row?.shopCode})`,
    type: 'string'
  },
  {
    title: 'Raion',
    field: 'rayCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Familie',
    field: 'famCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Subfamilie',
    field: 'sfaCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Cod UB',
    field: 'ubCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Cod Produs',
    field: 'prodCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Sters',
    field: 'deleted',
    render: row => row.deleted ? "Da" : "Nu",
    align: 'left',
    type: 'string'
  }
]

export const drawerFilters = (shopTypes, metiRayons, metiFamilies, metiSubfamilies, metiUB) => [
  {
    name: 'shopCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        disableClearable
        options={shopTypes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'rayCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează raion"
        disableClearable
        options={metiRayons || []}
      />
    ),
    type: 'autocomplete',
    label: 'Raion'
  },
  {
    name: 'famCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Familie"
        disableClearable
        options={metiFamilies || []}
      />
    ),
    type: 'autocomplete',
    label: 'Familie'
  },
  {
    name: 'sfaCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Subfamilie"
        disableClearable
        options={metiSubfamilies || []}
      />
    ),
    type: 'autocomplete',
    label: 'Subfamilie'
  },
  {
    name: 'ubCode',
    value: '',
    filter: (
      <Autocomplete variant="outlined" label="Cod UB" disableClearable options={metiUB || []} />
    ),
    type: 'autocomplete',
    label: 'Cod UB'
  },
  {
    name: 'prodCode',
    value: '',
    filter: <Input variant="outlined" label="Cod produs" type="text" />,
    type: 'text',
    label: 'Cod produs'
  },
  {
    name: 'deleted',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Sters"
        disableClearable
        options={[
          {
            value: 'true',
            label: 'Da'
          },
          {
            value: 'false',
            label: 'Nu'
          }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Sters'
  }
]
